import React from 'react';
import {
    Container,
    Content,
    Button,
    Title,
    Red,
    Text,
    Wrapper,
    BackgroundImage
} from './styled';
import { mainDescription } from './data';

const Main = ({ type, city }) => {
    const activeIndex = mainDescription.findIndex(item => item.key === type);

    function handleClick() {
        window.fbq('track', 'lead_head');
        window._tmr.push({ id: '3213734', type: 'reachGoal', goal: 'lead_head' });
        window.location = '#request';
    }

    let title = <Title>Видеонаблюдение <Red>для квартиры</Red> и <Red>частного дома</Red> от Дом.ru</Title>;

    if (city.domain === 'interzet') {
        title = <Title>Видеонаблюдение <Red>для квартиры</Red> и <Red>частного дома</Red> от Дом.ru в {city.cityIn}</Title>;
    }

    return <Wrapper>
        <Container>
            <Content>
                {title}
                <Text>
                    {mainDescription[activeIndex] ? mainDescription[activeIndex].text : mainDescription[4].text}
                </Text>
                <Button text='Подключить' onClick={() => handleClick()}/>
            </Content>
        </Container>
        <BackgroundImage width='800' height='640' viewBox='0 0 800 640' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M400 640L480 640L520 600L440 600L400 640Z' fill='#ED3D3D'/>
                <path d='M440 600L520 600L520 560L440 560L440 600Z' fill='#FC7479'/>
                <path d='M440 560L520 560L560 520L480 520L440 560Z' fill='#ED3D3D'/>
                <path d='M520 400L600 400L640 360L560 360L520 400Z' fill='#ED3D3D'/>
                <path d='M480 480L560 480L600 440L520 440L480 480Z' fill='#ED3D3D'/>
                <path d='M560 320L640 320L680 280L600 280L560 320Z' fill='#ED3D3D'/>
                <path d='M480 520L560 520L560 480L480 480L480 520Z' fill='#FC7479'/>
                <path d='M560 360L640 360L640 320L560 320L560 360Z' fill='#FC7479'/>
                <path d='M520 440L600 440L600 400L520 400L520 440Z' fill='#FC7479'/>
                <path d='M600 280L680 280L680 240L600 240L600 280Z' fill='#FC7479'/>
                <path d='M600 240L680 240L720 200L640 200L600 240Z' fill='#ED3D3D'/>
                <path d='M680 80L760 80L800 40L720 40L680 80Z' fill='#ED3D3D'/>
                <path d='M640 160L720 160L760 120L680 120L640 160Z' fill='#ED3D3D'/>
                <path d='M640 200L720 200L720 160L640 160L640 200Z' fill='#FC7479'/>
                <path d='M720 40L800 40L800 -6.99382e-06L720 0L720 40Z' fill='#FC7479'/>
                <path d='M680 120L760 120L760 80L680 80L680 120Z' fill='#FC7479'/>
                <path d='M440 560L360 560L320 600L400 600L440 560Z' fill='#ED3D3D'/>
                <path d='M400 600L320 600L320 640L400 640L400 600Z' fill='#FC7479'/>
                <path d='M600 240L520 240L480 280L560 280L600 240Z' fill='#ED3D3D'/>
                <path d='M520 400L440 400L400 440L480 440L520 400Z' fill='#ED3D3D'/>
                <path d='M560 320L480 320L440 360L520 360L560 320Z' fill='#ED3D3D'/>
                <path d='M480 480L400 480L360 520L440 520L480 480Z' fill='#ED3D3D'/>
                <path d='M560 280L480 280L480 320L560 320L560 280Z' fill='#FC7479'/>
                <path d='M480 440L400 440L400 480L480 480L480 440Z' fill='#FC7479'/>
                <path d='M520 360L440 360L440 400L520 400L520 360Z' fill='#FC7479'/>
                <path d='M440 520L360 520L360 560L440 560L440 520Z' fill='#FC7479'/>
                <path d='M680 80L600 80L560 120L640 120L680 80Z' fill='#ED3D3D'/>
                <path d='M720 0L640 6.99382e-06L600 40L680 40L720 0Z' fill='#ED3D3D'/>
                <path d='M640 160L560 160L520 200L600 200L640 160Z' fill='#ED3D3D'/>
                <path d='M640 120L560 120L560 160L640 160L640 120Z' fill='#FC7479'/>
                <path d='M680 40L600 40L600 80L680 80L680 40Z' fill='#FC7479'/>
                <path d='M600 200L520 200L520 240L600 240L600 200Z' fill='#FC7479'/>
                <path d='M200 640L280 640L320 600L240 600L200 640Z' fill='#ED3D3D'/>
                <path d='M240 600L320 600L320 560L240 560L240 600Z' fill='#FC7479'/>
                <path d='M240 560L320 560L360 520L280 520L240 560Z' fill='#ED3D3D'/>
                <path d='M320 400L400 400L440 360L360 360L320 400Z' fill='#ED3D3D'/>
                <path d='M280 480L360 480L400 440L320 440L280 480Z' fill='#ED3D3D'/>
                <path d='M360 320L440 320L480 280L400 280L360 320Z' fill='#ED3D3D'/>
                <path d='M280 520L360 520L360 480L280 480L280 520Z' fill='#FC7479'/>
                <path d='M360 360L440 360L440 320L360 320L360 360Z' fill='#FC7479'/>
                <path d='M320 440L400 440L400 400L320 400L320 440Z' fill='#FC7479'/>
                <path d='M400 280L480 280L480 240L400 240L400 280Z' fill='#FC7479'/>
                <path d='M400 240L480 240L520 200L440 200L400 240Z' fill='#ED3D3D'/>
                <path d='M480 80L560 80L600 40L520 40L480 80Z' fill='#ED3D3D'/>
                <path d='M440 160L520 160L560 120L480 120L440 160Z' fill='#ED3D3D'/>
                <path d='M440 200L520 200L520 160L440 160L440 200Z' fill='#FC7479'/>
                <path d='M520 40L600 40L600 -6.99382e-06L520 0L520 40Z' fill='#FC7479'/>
                <path d='M480 120L560 120L560 80L480 80L480 120Z' fill='#FC7479'/>
                <path d='M240 560L160 560L120 600L200 600L240 560Z' fill='#ED3D3D'/>
                <path d='M200 600L120 600L120 640L200 640L200 600Z' fill='#FC7479'/>
                <path d='M400 240L320 240L280 280L360 280L400 240Z' fill='#ED3D3D'/>
                <path d='M320 400L240 400L200 440L280 440L320 400Z' fill='#ED3D3D'/>
                <path d='M360 320L280 320L240 360L320 360L360 320Z' fill='#ED3D3D'/>
                <path d='M280 480L200 480L160 520L240 520L280 480Z' fill='#ED3D3D'/>
                <path d='M360 280L280 280L280 320L360 320L360 280Z' fill='#FC7479'/>
                <path d='M280 440L200 440L200 480L280 480L280 440Z' fill='#FC7479'/>
                <path d='M320 360L240 360L240 400L320 400L320 360Z' fill='#FC7479'/>
                <path d='M240 520L160 520L160 560L240 560L240 520Z' fill='#FC7479'/>
                <path d='M480 80L400 80L360 120L440 120L480 80Z' fill='#ED3D3D'/>
                <path d='M520 0L440 6.99382e-06L400 40L480 40L520 0Z' fill='#ED3D3D'/>
                <path d='M440 160L360 160L320 200L400 200L440 160Z' fill='#ED3D3D'/>
                <path d='M440 120L360 120L360 160L440 160L440 120Z' fill='#FC7479'/>
                <path d='M480 40L400 40L400 80L480 80L480 40Z' fill='#FC7479'/>
                <path d='M400 200L320 200L320 240L400 240L400 200Z' fill='#FC7479'/>
            </BackgroundImage>
    </Wrapper>;
};

export default Main;
